import { motion } from 'framer-motion';
import { AnimatedSection } from './AnimatedSection';
import { usePublicConfig } from '../context';

const getTestimonials = (chamaName: string) => [
  {
    quote:
      'We used to spend hours on WhatsApp coordinating contributions. Now everything is automated—M-Pesa confirmations, reminders, payouts. Our chama finally feels professional.',
    name: 'Mary W.',
    role: 'Chairperson, Nairobi Chama',
  },
  {
    quote:
      'No more Excel nightmares or missed payments. I can see who paid, who owes, and when the next payout is—all from my phone. Game changer.',
    name: 'John K.',
    role: 'Treasurer, Mombasa Investment Group',
  },
  {
    quote:
      'Members love having their own login to check balances anytime. No more "How much have I contributed?" messages at midnight. Total transparency.',
    name: 'Grace M.',
    role: 'Secretary, Kikuyu Women Chama',
  },
];

export const Testimonials = () => {
  const { config: publicConfig } = usePublicConfig();
  const chamaName = publicConfig?.name ?? 'LoopFund';
  const testimonials = getTestimonials(chamaName);

  return (
  <AnimatedSection
    id="faqs"
    className="section-padding mx-auto max-w-6xl lg:px-0"
    delay={0.1}
  >
    <div className="mb-12 text-center">
      <h2 className="font-display text-3xl text-slate-900 md:text-4xl dark:text-white">
        Real chamas, real results
      </h2>
      <p className="mt-3 text-base text-slate-500 dark:text-slate-300">
        Join dozens of chamas across Kenya who've ditched WhatsApp chaos for professional management. {chamaName} is just one example.
      </p>
    </div>

    <div className="grid gap-6 lg:grid-cols-3">
      {testimonials.map((testimonial, index) => (
        <motion.blockquote
          key={testimonial.name}
          initial={{ opacity: 0, y: 22 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{
            duration: 0.6,
            delay: index * 0.12,
            ease: [0.16, 1, 0.3, 1],
          }}
          viewport={{ once: true, amount: 0.4 }}
          className="h-full rounded-3xl border border-slate-200 bg-slate-50 p-7 text-left shadow-sm dark:border-slate-700 dark:bg-slate-800"
        >
          <p className="text-base leading-relaxed text-slate-700 dark:text-slate-100">
            "{testimonial.quote}"
          </p>
          <footer className="mt-6 text-sm font-medium text-slate-900 dark:text-slate-100">
            {testimonial.name}
            <span className="block text-xs font-normal uppercase tracking-[0.3em] text-slate-400 dark:text-slate-500">
              {testimonial.role}
            </span>
          </footer>
        </motion.blockquote>
      ))}
    </div>
  </AnimatedSection>
  );
};
